import type { Actions } from '../../../common/types.tsx';

const restoreState: Actions['restoreState'] =
	(stateToRestore) =>
	({ setState }) => {
		setState(stateToRestore);
	};

export default restoreState;
